<template>
  <section id="pricing" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-card style="width: 100%">
            <h1 class="text-center pt-6 font-weight-light display-2">
              Serviços
            </h1>
            <v-divider class="my-6"></v-divider>
            <v-row class="text-center">
              <v-col class="col-12 col-sm-6 col-md-4">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="~@/assets/img/paperplane.svg"></v-img>
                        </div>
                      </div>
                    </div>
                    <div class="text--disabled text-uppercase text-h5 my-2">
                      Básico
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Aconselhamento inicial
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Atendimento de até 1h
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Levantar necessidades no Siproquim
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase text-h4 mt-6 blue--text">
                      R$ 750,00
                    </div>
                    <div class="text-uppercase blue--text">único</div>
                    <v-btn
                      v-bind="size"
                      rounded
                      outlined
                      color="blue"
                      class="mt-6"
                      @click="clkMarque(750, 'QR_basico.jpeg')"
                    >
                      Marque Agora
                    </v-btn>
                  </v-card-text>
                  <v-divider
                    style="margin-right: -23px"
                    vertical
                    v-if="this.$vuetify.breakpoint.smAndUp"
                  ></v-divider>
                </div>
                <v-divider
                  class="mx-4"
                  v-if="!this.$vuetify.breakpoint.smAndUp"
                ></v-divider>
              </v-col>
              <v-col class="col-12 col-sm-6 col-md-4">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img
                            src="~@/assets/img/airplane.svg"
                            @load="mixpanel.track('Carregou o avião- Serviços')"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="text--disabled text-uppercase text-h5 my-2">
                      Padrão
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Acertos diretamente no Siproquim
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Sem tempo limite
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Acesso remoto e aconselhamento
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase text-h4 mt-6 blue--text">
                      R$ 1280,00
                    </div>
                    <div class="text-uppercase blue--text">único</div>
                    <v-btn
                      v-bind="size"
                      rounded
                      outlined
                      color="blue"
                      class="mt-6"
                      @click="clkMarque(1280, 'QR_padrao.jpeg')"
                    >
                      Marque Agora
                    </v-btn>
                  </v-card-text>
                  <v-divider
                    style="margin-right: -23px"
                    vertical
                    v-if="this.$vuetify.breakpoint.mdAndUp"
                  ></v-divider>
                </div>
                <v-divider
                  class="mx-4"
                  v-if="!this.$vuetify.breakpoint.smAndUp"
                ></v-divider>
              </v-col>
              <v-col class="col-12 col-md-4">
                <v-divider
                  v-if="this.$vuetify.breakpoint.smOnly"
                  class="mx-4"
                ></v-divider>

                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="~@/assets/img/aeroplane.svg" />
                        </div>
                      </div>
                    </div>
                    <div class="text--disabled text-uppercase text-h5 my-2">
                      Empresarial
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Todos as características do padrão
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Acompanhamento contínuo
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase blue--text">
                      Equipe de sobre-aviso<sup>1</sup>
                    </div>
                    <v-divider class="my-2" />
                    <div class="text-uppercase text-h4 mt-6 blue--text">
                      R$ 1950,00
                    </div>
                    <div class="text-uppercase blue--text">/mês</div>

                    <v-btn
                      v-bind="size"
                      rounded
                      outlined
                      color="blue"
                      class="mt-6"
                      @click="clkMarque(1950, 'QR_empresarial.jpeg')"
                    >
                      Inicie Agora
                    </v-btn>
                  </v-card-text>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            :fullscreen="$vuetify.breakpoint.mobile"
            max-width="1000px"
          >
            <v-card>
              <v-toolbar color="secondary" dark>
                <v-btn icon color="white" @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="white--text">Marcação</v-toolbar-title>
              </v-toolbar>
              <v-stepper v-model="e1">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" step="1">
                    Pagamento
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2">
                    Marcação
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-card-text>
                      <br />
                      <h3 class="text-uppercase font-weight-regular">
                        Nome: Sababa
                      </h3>
                      <h3 class="text-uppercase font-weight-regular">
                        CNPJ: 45.***.350/0001-**
                      </h3>
                      <h3 class="text-uppercase font-weight-regular">
                        Valor: {{ preco }},00
                      </h3>
                    </v-card-text>
                    <v-img
                      contain
                      :max-width="250"
                      src="../assets/img/QR_basico.jpeg"
                      v-show="'../assets/img/QR_basico.jpeg' == qrCode"
                    />
                    <v-img
                      contain
                      :max-width="250"
                      src="../assets/img/QR_empresarial.jpeg"
                      v-show="'../assets/img/QR_empresarial.jpeg' == qrCode"
                    />
                    <v-img
                      contain
                      :max-width="250"
                      src="../assets/img/QR_padrao.jpeg"
                      v-show="'../assets/img/QR_padrao.jpeg' == qrCode"
                    />
                    <v-form
                      ref="form"
                      lazy-validation
                      @submit.prevent="sendComprovante"
                    >
                      <v-text-field
                        v-model="profileName"
                        :rules="nameRules"
                        :counter="70"
                        label="Contratante"
                        required
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="profileEmail"
                        :rules="emailRules"
                        label="Email"
                        required
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="profilePhone"
                        :rules="phoneRules"
                        hint="(DDD)XXXXX-XXXX"
                        label="Telefone com DDD"
                        required
                      >
                      </v-text-field>
                      <v-file-input
                        v-model="image"
                        truncate-length="15"
                        label="Foto do comprovante"
                        placeholder="Foto do comprovante"
                        :rules="rules"
                        accept="image/png, image/jpeg, image/bmp"
                        required
                      ></v-file-input>
                      <v-checkbox
                        v-model="checkbox"
                        required
                        :rules="checkRules"
                        label="Aceito compartilhar os dados pessoais acima com a empresa listada no pagamento para receber contato sobre a prestação de serviços divulgada. Entendo que meus dados serão armazenados e tratados de acordo com a lei LGPD"
                      ></v-checkbox>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn color="error" text @click="dialog = false">
                          Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="dark-blue"
                          outlined
                          type="submit"
                          :loading="loadSubmit"
                          :disabled="loadSubmit"
                        >
                          Enviar Comprovante
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <vue-calendly
                      url="https://calendly.com/israelsaba/consultoria-siproquim"
                      @load="mixpanel.track('Carregando dialog marcação')"
                      :height="780"
                    ></vue-calendly>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
            <v-snackbar
              v-model="snackbar.enabled"
              timeout="3000"
              right
              top
              :color="snackbar.color"
            >
              {{ snackbar.text }}

              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.enabled = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          </v-dialog>
        </v-col>
      </v-row>
      <div class="svg-border-rounded text-light">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 144.54 17.34"
          preserveAspectRatio="none"
          fill="currentColor"
        >
          <path
            d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
          fill="currentColor"
        >
          <path
            d="M0,64L80,90.7C160,117,320,171,480,181.3C640,192,800,160,960,138.7C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>
    </v-container>
  </section>
</template>

<style lang="scss">
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.header {
  background-color: #283e79;
  color: white;
}

.circle1 {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle2 {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}

#pricing {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
</style>

<script>
import { db, mixpanel, storage } from "@/main";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export default {
  data: () => ({
    calendlyLoading: true,
    mixpanel: mixpanel,
    profileName: "",
    profileEmail: "",
    profilePhone: "",
    loadSubmit: false,
    checkbox: false,
    image: null,
    e1: 1,
    preco: "",
    qrCode: null,
    nameRules: [
      //TODO: avoid submission with errors (snackbar to give user a feedback)
      (v) => !!v || "Falta o nome",
      (v) => {
        if (v) {
          if (v.length > 70) return "Limite de caracteres excedido";
          else return true;
        } else return true;
      },
    ],
    emailRules: [
      (v) => !!v || "Necessário colocar um email",
      (v) => /.+@.+\..+/.test(v) || "Email deve ser válido",
    ],
    phoneRules: [
      (v) => !!v || "Necessário colocar um telefone",
      (v) =>
        /^\(?[1-9]{2}\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4}$/.test(v) ||
        "O telefone deve ser válido",
    ],
    rules: [
      (v) => !!v || "Necessário subir um comprovante",
      (value) => !value || value.size < 300000000 || "Fotos menores que 300MB",
    ],
    checkRules: [(v) => !!v || "Necessário concordar com os termos"],
    dialog: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
    planos: [
      {
        title: "Básico",
        price: "R$100,00",
        img: "f1.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 3",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 4",
          },
        ],
      },
      {
        title: "Padrão",
        price: "R$150,00",
        img: "f2.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 3",
            color: "success",
          },
          {
            icon: {
              text: "mdi-cancel",
              color: "red",
            },
            text: "Feature 4",
          },
        ],
      },
      {
        title: "Premium",
        price: "R$250,00",
        img: "f3.png",
        features: [
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 1",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 2",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 3",
            color: "success",
          },
          {
            icon: {
              text: "mdi-check",
              color: "success",
            },
            text: "Feature 4",
            color: "success",
          },
        ],
      },
    ],
  }),
  computed: {
    size() {
      const size = { md: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
  methods: {
    clkMarque(preco, img) {
      mixpanel.track("Marque/Inicie Agora Click");
      mixpanel.time_event("Carregando dialog marcação");
      this.dialog = true;
      this.e1 = 1;
      this.preco = preco;
      this.qrCode = "../assets/img/" + img;
    },
    consultaMarcada: function () {
      console.log("marcaram evento");
      this.snackbar.text = "Consultoria marcada com sucesso";
      this.snackbar.color = "success";
      this.snackbar.enabled = true;
    },
    async storeImage() {
      const image = this.image;
      let imageUrl = "images/" + uuidv4();
      const metadata = {
        customMetadata: {
          contratante: this.profileName,
          emailContratante: this.profileEmail,
          telefoneContratante: this.profilePhone,
        },
      };
      let imageRef = ref(storage, imageUrl);
      await uploadBytes(imageRef, image, metadata);
      return imageUrl;
    },
    async sendComprovante() {
      this.loadSubmit = true;
      if (this.$refs.form.validate()) {
        try {
          const urlImage = await this.storeImage();
          const docRef = await addDoc(collection(db, "contracts"), {
            created_at: Date.now(),
            nome: this.profileName,
            email: this.profileEmail,
            telefone: this.profilePhone,
            checkPrivacidade: this.checkbox,
            urlImage: urlImage,
          });
          this.loadSubmit = false;
          this.snackbar.text = "Comprovante enviado com sucesso";
          this.snackbar.color = "success";
          this.snackbar.enabled = true;
          this.e1 = 2;
          mixpanel.people.set({
            $email: this.profileName,
            $name: this.profileEmail,
            $phone: this.profilePhone,
            Anonymous: false,
          });
        } catch (e) {
          console.error("Error adding document: ", e);
          this.snackbar.text = "Erro ao enviar mensagem";
          this.snackbar.color = "danger";
          this.snackbar.enabled = true;
          console.error("Error adding document: ", e);
          this.loadSubmit = false;
        }
      } else this.loadSubmit = false;
    },
  },
  mounted() {
    function isCalendlyEvent(e) {
      return e.data.event && e.data.event.indexOf("calendly") === 0;
    }
    window.addEventListener("message", (e) => {
      if (isCalendlyEvent(e)) {
        mixpanel.track(e.data.event, e.data.payload);
        if (e.data.event == "calendly.event_scheduled") this.consultaMarcada();
      }
    });
  },
};
</script>